<template>
    <div class="login-wrap">
        <el-form label-position="left" :model="model" :rules="rules" ref="model" label-width="0px" class="demo-ruleForm login-container">
            <h1 class="title">数据中台后台管理系统</h1>
            <el-form-item prop="UserId" class="username">
                <el-input type="text" v-model="model.UserId" auto-complete="off" placeholder="请输入账号" @keyup.enter.native="submitForm" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item prop="UserPwd" class="userpsw">
                <el-input type="password" v-model="model.UserPwd" auto-complete="off" placeholder="请输入密码" @keyup.enter.native="submitForm" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item style="margin-top: 20px">
                <el-button type="primary" style="width:100%;" @click="submitForm">登录
                </el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    import { Auth, GetToken } from '../../api/login'
    import storage from '../../common/storage'
    export default {
        name: 'login',
        data() {
            return {
                logining: false,
                model: {
                    UserId: '',
                    UserPwd: '',
                },
                tokenPrams: {
                    Corpid: 'syuuAyDcTeuCl6f8t4',
                    Secret: 'p98hiBprwStDB7OEeQfqgmPt3xasdfxf',
                },
                rules: {
                    UserId: [{ required: true, message: '请输入用户ID', trigger: 'blur' }],
                    UserPwd: [{ required: true, message: '请输入用户姓名', trigger: 'blur' }],
                },
            }
        },
        methods: {
            Auth() {
                console.log(this.model)
                Auth(this.model).then(data => {
                    if (!data.iserror) {
                        this.$message({
                            message: '登录成功',
                            type: 'success'
                        });
                        let token = data.data.Access_Token;
                        let ConversationID = data.data.ConversationID;
                        let userinfo = {
                            Uid: data.data.Uid,
                            Uname: data.data.Uname,
                        }
                        console.log(data)
                        console.log(userinfo)
                        storage.setSession('token', token);
                        storage.setSession('ConversationID', ConversationID);
                        storage.setSession('userinfo', userinfo);
                        if (data.data.Uid == 'admin') {
                            this.$router.push({
                                path: '/userManage'
                            });
                        } else {
                            this.$router.push({
                                path: '/unitManage'
                            });
                        }
                    }
                })
            },
            submitForm() {
                this.$refs.model.validate(valid => {
                    if (valid) {
                        this.Auth();
                    } else {
                        this.$message({
                            message: '请填写完整信息',
                            type: 'error'
                        })
                    }
                })
            },
            keyupEnter() {
                document.onkeydown = e => {
                    if (e.keyCode === 13 && e.target.baseURI.match(/login/)) {
                        this.submitForm()
                    }
                }
            },
        }
    }
</script>

<style>
    @import url('../../../public/static/css/login.css');
</style>